import { render, staticRenderFns } from "./studentAidGrantRecordList.vue?vue&type=template&id=306f4ae5&"
import script from "./studentAidGrantRecordList.vue?vue&type=script&lang=ts&"
export * from "./studentAidGrantRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports